export default __webpack_public_path__ + "static/media/phoneDetailMb4.9b00ee60.png";